import {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import { Tooltip } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';

import Loading from '../../common/Loading';
import LoadListDetailsOwnershipAssignedToLookup from './LoadListDetailsOwnershipAssignedToLookup';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function LoadListDetailsOwnershipAssignedToDisplay(props) {
    console.debug('RTS Break LoadListDetailsOwnershipAssignedToDisplay');

    const history = useNavigate();

    const {sessionCustomer} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);

    const [showAssignedToModal, setShowAssignedToModal] = useState(false);
    const [showContractModal, setShowContractModal] = useState(false);
    const [showReturnReelModal, setShowReturnReelModal] = useState(false);    
    const [assignedToLink, setAssignedToLink] = useState();


    useEffect(() => {
        setAssignedToLink(props.data.assignedToLink);
        setIsLoading(false);
    }, [props.data.assignedToLink]); 


    function getAssignedToLinkDisplay(){
        if(assignedToLink != null){
            if(assignedToLink.linkCustomer!=null){
                 return assignedToLink.name + " (" + assignedToLink.linkCustomer.idSap + ")";
            }
            else{
                return assignedToLink.name;
            }
        }
        else{
            return props.data.soldToCustomer.name;
        }
    }


    function verifySetAssignedTo(){
        if(props.data.contractToLink != null){
            setShowContractModal(true);
        } 
        else{
            setShowAssignedToModal(true); 
        }       
    }


    function setAssignedToLinkVal(pVal){
        setAssignedToLink(pVal);
        props.setAssignedToLinkFx(pVal);
        setShowAssignedToModal(false);
        props.setFormDirtyFx(1);
    }


    function returnReelToSoldTo(){
        setAssignedToLink(props.data.soldToCustomer);
        props.setAssignedToLinkFx(null);
        setShowReturnReelModal(false);
        props.setFormDirtyFx(1);
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    if(props.data.soldToCustomer.idGuid === sessionCustomer.customer.idGuid
        && props.data.assignedToCustomer.idGuid === sessionCustomer.customer.idGuid){
        return (
            <>
            <Dialog fullWidth={true} maxWidth="md" open={showAssignedToModal} onClose={()=>{setShowAssignedToModal(false);}}>
                <DialogTitle>Assign To</DialogTitle>
                <DialogContent>
                    <Box>
                        <LoadListDetailsOwnershipAssignedToLookup assignedToLink={assignedToLink} setAssignedToLinkFx={setAssignedToLinkVal} />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={e => {setShowAssignedToModal(false);}} sx={{mr:2}}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog maxWidth="md" open={showContractModal} onClose={()=>{setShowContractModal(false);}}>
                <DialogTitle>Remove Contract To</DialogTitle>
                <DialogContent>
                    <Box>
                        <Typography>Setting the Assigned To value will remove the Contract To value.</Typography>
                        <Typography>Continue?</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={e => {setShowAssignedToModal(true);}} sx={{mr:1}}>Yes</Button>
                    <Button variant="contained" onClick={() => {setShowContractModal(false);}} >Cancel</Button>
                </DialogActions>
            </Dialog>            
            <Box id="AssignedToLink" sx={{display:'flex', alignItems:'center'}}>
                <TextField
                    id="tbAssignedTo"
                    margin="normal"
                    fullWidth
                    label="Assigned To"
                    size="small"
                    value={getAssignedToLinkDisplay()}
                    onClick={verifySetAssignedTo}
                />
                <Box sx={{ml:1, mt:1}}>            
                    <Button variant="contained" onClick={verifySetAssignedTo}>
                        <SearchIcon sx={{fontSize:'2em'}} />
                    </Button>
                </Box>            
            </Box>
            </>
        );
    }
    else if(props.data.assignedToCustomer.idGuid === sessionCustomer.customer.idGuid){
        return (
            <>
            <Dialog maxWidth="md" open={showReturnReelModal} onClose={()=>{setShowReturnReelModal(false);}}>
                <DialogTitle>Return Reel</DialogTitle>
                <DialogContent>
                    <Box>
                        <Typography>Set the Assigned To value back to the Sold To value?</Typography>
                        <Box sx={{mt:2, display:'flex', justifyContent:'center'}}>
                            <Typography variant='caption' color='red'>*This will also remove the Contract To value.</Typography>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={e => {returnReelToSoldTo();}} sx={{mr:1}}>Yes</Button>
                    <Button variant="contained" onClick={() => {setShowReturnReelModal(false);}} >Cancel</Button>
                </DialogActions>
            </Dialog>
            <Box id="AssignedToLink" sx={{display:'flex', alignItems:'center'}}>
                <TextField
                    id="tbAssignedTo"
                    margin="normal"
                    fullWidth
                    label="Assigned To"
                    size="small"
                    value={getAssignedToLinkDisplay()}
                    onClick={()=>{setShowReturnReelModal(true);}}
                    disabled={true}
                />
                <Box sx={{ml:1, mt:1}}> 
                    <Tooltip title="Return Reel to Sold To">           
                        <Button variant="contained" onClick={()=>{setShowReturnReelModal(true);}}>
                            <AssignmentReturnIcon sx={{fontSize:'2em'}} />
                        </Button>
                    </Tooltip>
                </Box>            
            </Box>
            </>
        );
    }
    else{
        return(
            <Box id="AssignedToLinkDis" sx={{display:'flex', alignItems:'center'}}>
                <TextField
                    id="tbAssignedToDis"
                    margin="normal"
                    fullWidth
                    label="Assigned To"
                    size="small"
                    value={getAssignedToLinkDisplay()}
                    disabled={true}
                />
            </Box>
        )
    }

}
